import { NOT_FOUND } from 'http-status-codes'

import { ErrorBase } from './ErrorBase'

export class NoTeamAvailableError extends ErrorBase {
  name = 'NoTeamAvailableError'

  constructor (message) {
    super(message, null, NOT_FOUND)
  }
}
